import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Dialog } from "../../../../../components/primitives/feedback/Dialog";
import type { FieldReannotationRow } from "./useFieldReannotationPanel";

function labelsText(labels: string[]): string {
  return labels.length > 0 ? labels.join(", ") : "none";
}

interface JustificationProps {
  heading: string;
  labels: string[];
  justification: string | null | undefined;
}

function Justification({ heading, labels, justification }: JustificationProps) {
  return (
    <Stack gap={0.5}>
      <Typography variant="subtitle2">
        {heading}: {labelsText(labels)}
      </Typography>
      <Typography variant="body2" color={justification ? "text.primary" : "text.secondary"}>
        {justification ?? "No justification was recorded."}
      </Typography>
    </Stack>
  );
}

export interface FieldReannotationJustificationsDialogProps {
  row: FieldReannotationRow | null;
  onClose: () => void;
}

/** The AI's reasoning behind a re-annotation's labels, before and after. Justifications are kept
 *  from the moment they were introduced on, so older items show none. */
export function FieldReannotationJustificationsDialog({
  row,
  onClose,
}: FieldReannotationJustificationsDialogProps) {
  const change = row?.result?.change ?? null;
  return (
    <Dialog
      open={row !== null}
      onClose={onClose}
      title={row?.item.subjectTitle ?? "AI justification"}
      dividers
    >
      {change && (
        <Stack gap={2}>
          <Justification
            heading="Before"
            labels={change.before}
            justification={change.beforeJustification}
          />
          <Justification
            heading="After"
            labels={change.after}
            justification={change.afterJustification}
          />
        </Stack>
      )}
    </Dialog>
  );
}
